import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

let campaignSummaryFetchGeneration = 0;

const unwrap = (response) => response?.data?.data ?? response?.data ?? null;

const CampaignSummary = {
  name: 'campaignSummary',
  state: {
    loading: false,
    playsPending: false,
    metricsPending: false,
    error: '',
    data: null,
    lastQuery: null,
  },
  reducers: {
    requestStarted(state, payload) {
      return {
        ...state,
        loading: true,
        playsPending: true,
        metricsPending: true,
        error: '',
        lastQuery: payload || null,
        data: null,
      };
    },
    playsReceived(state, payload) {
      const prevOverall = state.data?.overall_campaigns_summary || {};
      const incoming = payload?.overall_campaigns_summary || {};
      const nextOverall = { ...prevOverall, ...incoming };
      const playsPending = false;
      return {
        ...state,
        data: { overall_campaigns_summary: nextOverall },
        playsPending,
        loading: state.metricsPending,
      };
    },
    metricsReceived(state, payload) {
      const prevOverall = state.data?.overall_campaigns_summary || {};
      const incoming = payload?.overall_campaigns_summary || {};
      const nextOverall = { ...prevOverall, ...incoming };
      const metricsPending = false;
      return {
        ...state,
        data: { overall_campaigns_summary: nextOverall },
        metricsPending,
        loading: state.playsPending,
      };
    },
    requestFailed(state, payload) {
      return {
        ...state,
        loading: false,
        playsPending: false,
        metricsPending: false,
        error: payload || 'Failed to load campaign summary',
        data: null,
      };
    },
    clearState() {
      return {
        loading: false,
        playsPending: false,
        metricsPending: false,
        error: '',
        data: null,
        lastQuery: null,
      };
    },
  },
  effects: (dispatch) => ({
    async fetch(data) {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      const start_date = data?.start_date;
      const end_date = data?.end_date;
      const view = data?.view || 'dso';
      const granularity = data?.granularity || 'monthly';
      const status = data?.status || 'active';
      const org_id = userInfo?.org_id;

      if (!start_date || !end_date || !org_id) {
        this.requestFailed('Missing required summary query fields');
        return;
      }

      const query = [
        `start_date=${encodeURIComponent(start_date)}`,
        `end_date=${encodeURIComponent(end_date)}`,
        `view=${encodeURIComponent(view)}`,
        `granularity=${encodeURIComponent(granularity)}`,
        `status=${encodeURIComponent(status)}`,
        `org_id=${encodeURIComponent(org_id)}`,
      ].join('&');

      const generation = ++campaignSummaryFetchGeneration;
      this.requestStarted({ start_date, end_date, view, granularity, status, org_id });

      const fail = (err) => {
        if (generation !== campaignSummaryFetchGeneration) return;
        campaignSummaryFetchGeneration += 1;
        const message =
          err?.response?.data?.message || err?.message || 'Failed to load campaign summary';
        this.requestFailed(message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(message),
            show: true,
          },
        });
      };

      const playsUrl = `savvy/campaigns/reports/campaign-summary/plays?${query}`;
      const metricsUrl = `savvy/campaigns/reports/campaign-summary/metrics?${query}`;

      http
        .get(playsUrl)
        .then((response) => {
          if (generation !== campaignSummaryFetchGeneration) return;
          this.playsReceived(unwrap(response));
        })
        .catch(fail);

      http
        .get(metricsUrl)
        .then((response) => {
          if (generation !== campaignSummaryFetchGeneration) return;
          this.metricsReceived(unwrap(response));
        })
        .catch(fail);
    },
  }),
};

export default CampaignSummary;
